import Layout from '../../components/Layout';
import React, {Fragment, useContext, useEffect, useState} from 'react';
import {StepStatus, useAppContext} from '../../context/app-context';
import {useAuthContext, useClient} from 'app/gakki/context/auth-context';
import {QuestionContainer} from '../../components/Layout/question';
import {useForm, FormProvider} from 'react-hook-form';
import {useMutation} from 'react-query';
import usePageData from '../../../../hooks/usePageData';
import NormalShiftQuestion from './components/normal-shift-question';
import ElasticWorkingTimeQuestion from './components/elastic-working-time-question';
import ShiftScheduleQuestion from './components/shift-schedule-question';
import {AttendanceQuestions} from '../../api/types';
import {toast} from 'react-toastify';

const defaultValues: AttendanceQuestions = {
  standardWorkingTime: {
    workOnTime: '09:00',
    workOffTime: '18:00',
    dayStartTime: '02:00',
    baseLine: '08:00',
    restTimes: [
      {
        startTime: '12:00',
        endTime: '13:00',
      },
    ],
  },
  elasticWorkingTime: {
    isEnabled: false,
    elasticScaleBefore: 30,
    elasticScaleAfter: 30,
    unitOfTime: 1,
  },
  scheduleInfo: {
    hasEnabled: false,
    workingHourType: 0,
    scheduleDaysInEveryMonth: {
      start: 1,
      end: 31,
    },
    scheduleItems: [],
  },
};

function AttendanceQuestion() {
  const api = useClient();
  const {companyId} = useAuthContext();
  const {
    data,
    status,
    remove: removeData,
    init,
    edit,
    updatedTime,
  } = usePageData<AttendanceQuestions>('attendance-question', defaultValues);
  const {
    changeStep,
    setIsLoading,
    step,
    isLoading,
    save,
    saveAndGoStep,
    saveFail,
    confirm,
    refetchEnablePY,
    onPrev,
  } = useAppContext();
  const saveData = (data: AttendanceQuestions) => {
    return api.put(`attendance/company/${companyId}/schedule/introduction`, {
      data,
    });
  };

  const confirmData = () => {
    return api.put(
      `attendance/company/${companyId}/schedule/introduction/confirm`,
    );
  };
  const {mutate: saveMutate} = useMutation(saveData, {
    onSuccess: () => save(),
    onError: () => saveFail(),
    onMutate: () => setIsLoading(true),
    onSettled: () => setIsLoading(false),
  });
  const {mutate: handleConfirm} = useMutation(
    (data: AttendanceQuestions) => saveData(data)
    .then(() => refetchEnablePY('next', step + 1))
    .then(async () => {
      try {
        await confirmData()
        setIsLoading(false)
        confirm();
        changeStep(step + 1);
        removeData();
      } catch (e: any) {
        setIsLoading(false)
        throw new Error(e);
      }
    }),
    {
      onMutate: () => setIsLoading(true),
    },
  );

  const formMethods = useForm<AttendanceQuestions>({
    defaultValues: data,
  });

  const {
    handleSubmit,
    reset,
    getValues,
  } = formMethods;

  useEffect(() => {
    setIsLoading(true);
    if (data !== null && status !== StepStatus.init) {
      setIsLoading(false);
      reset(data);
      return;
    }
    api
      .get(`attendance/company/${companyId}/schedule/introduction`)
      .then(res => {
        if (!res?.data || res?.data?.standardWorkingTime?.workOnTime === null) {
          reset(defaultValues);
          init(defaultValues);
        } else {
          reset(res?.data);
          init(res?.data);
        }
      })
      .finally(() => setIsLoading(false));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (typeof saveAndGoStep === 'number') {
      saveMutate(getValues())
    }
  }, [saveAndGoStep])

  const handlePrev = async () => {
    await onPrev();
    removeData();
  };

  function handleChange() {
    const values = getValues();
    edit(values);
  }

  return (
    <Fragment>
      <QuestionContainer title={'上下班/彈性工時設定'}>
        <FormProvider {...formMethods}>
          <NormalShiftQuestion
            onChange={() => {
              console.info('normal:');
              handleChange();
            }}
          />
          <ElasticWorkingTimeQuestion
            onChange={() => {
              console.info('elastic:');
              handleChange();
            }}
          />
          <ShiftScheduleQuestion
            onChange={() => {
              console.info('shift:');
              handleChange();
            }}
          />
        </FormProvider>
      </QuestionContainer>
      <Layout.Footer
        showNextButton
        showPrevButton
        showSaveButton
        onPrev={handlePrev}
        onNext={handleSubmit((v: AttendanceQuestions) => handleConfirm(v))}
        onSave={() => saveMutate(getValues())}
        updatedTime={updatedTime}
        disabledSaveButton={status !== StepStatus.edit || isLoading}
        disabledPrevButton={status === StepStatus.edit || isLoading}
        disabledNextButton={isLoading}
      />
    </Fragment>
  );
}
export default AttendanceQuestion;
